<template>
	<section>
		<header-simple :title="$t('Personal Information')" :subtitle="$t('Personal information about the patient.')">
			<action-button @click="editProfile" :title="$t('Edit information')" />
		</header-simple>
		<detail-panel>
			<div class="columns">
				<div class="column-s">
					<detail-panel-item-picture :src="patient.picture" />
				</div>
				<div class="column-m">
					<detail-panel-item :label="$t('labels.general.name')" :value="patient.name" />
					<detail-panel-item :label="$t('labels.general.birthdate')" :value="profile.birthday" />
					<detail-panel-item :label="$t('labels.general.blood_type')" :value="profile.blood_type" />
					<detail-panel-item :label="$t('labels.general.height')" :value="height + ' m'" />
					<detail-panel-item :label="$t('labels.general.weight')" :value="weight + ' kg'" />
					<detail-panel-item :label="$t('labels.general.gender')" :value="gender" />
				</div>
			</div>
		</detail-panel>
		<watch-profile-personal-information-form v-if="modalProfileForm.open" :params="modalProfileForm.params" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal('modalProfileForm', arguments)" />
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import DetailPanel from '@/modules/ui/DetailPanel'
import DetailPanelItem from '@/modules/ui/DetailPanelItem'
import DetailPanelItemPicture from '@/modules/ui/DetailPanelItemPicture'
import HeaderSimple from '@/modules/ui/HeaderSimple'
import ActionButton from '@/modules/ui/ActionButton'
import WatchProfilePersonalInformationForm from '@/components/watch/profile/watchProfile/WatchProfilePersonalInformationForm'
export default {
	name: 'watch-profile-personal-information',
	components: {
		DetailPanel,
		DetailPanelItem,
		DetailPanelItemPicture,
		HeaderSimple,
		ActionButton,
		WatchProfilePersonalInformationForm
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data() {
		return {
			patient: {},
			modalProfileForm: {
				open: false,
				params: {}
			}
		}
	},
	computed: {
		profile() {
			return this.patient.profile
		},
		gender() {
			return this.profile.gender === 'M' ? this.$t('Male') : this.$t('Female')
		},
		weight() {
			return (this.profile.weight / 1000).toFixed(2)
		},
		height() {
			return (this.profile.height / 100).toFixed(2)
		},
		...mapGetters({
			getPatient: 'PATIENT'
		})
	},
	methods: {
		editProfile() {
			this.openModal('modalProfileForm', { action: 'edit' })
		},
		openModal (modal, params = {}) {
			this[modal].open = true
			this[modal].params = params
		},
		closeModal (modal, args) {
			this[modal].open = false
			this[modal].params = {}
		}
	},
	created () {
		this.patient = this.getPatient(parseInt(this.watch_id))
	}
}
</script>

<style scoped>
.columns {
	display: flex;
	align-items: flex-start;
}
.column-s {
	flex: 1;
	display: flex;
	justify-content: center;
	max-width: 256px;
	width: 100%;
}
.column-m {
	flex: 2;
	margin-left: 40px;
}
@media screen and (max-width: 768px) {
	.columns {
		flex-direction: column;
	}
	.column-s {
		height: 256px;
		align-self: center;
	}
	.column-m {
		margin-top: 20px;
		margin-left: 0;
		flex: 1;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/watch/profile/watchProfile/WatchProfilePersonalInformation.vue